import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PolicyTermService {

  constructor() { }

  openPrivacyPolicy() {
    window.open('https://www.alelo.com.br/politica-privacidade', '_blank', 'noopener,noreferrer');
  }
}
